var map = {
	"./arrow-left.svg": "ac3b",
	"./arrow-right.svg": "cd8c",
	"./circle.svg": "b289",
	"./expand.svg": "8336",
	"./explicit.svg": "12b7",
	"./github.svg": "14f6",
	"./heart-solid.svg": "b877",
	"./heart.svg": "7d16",
	"./list.svg": "99ad",
	"./lock.svg": "9619",
	"./logout.svg": "69e3",
	"./mail.svg": "3ae9",
	"./mobile.svg": "0df4",
	"./more.svg": "0f4c",
	"./next.svg": "0043",
	"./pause.svg": "644b",
	"./play.svg": "dab1",
	"./previous.svg": "01ed",
	"./repeat-1.svg": "eca5",
	"./repeat.svg": "c015",
	"./search.svg": "d103",
	"./settings.svg": "9174",
	"./shuffle.svg": "00e6",
	"./translation.svg": "ec3b",
	"./volume-half.svg": "27c2",
	"./volume-mute.svg": "6a7b",
	"./volume.svg": "8901",
	"./x.svg": "7387"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";